import React, { useEffect, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import * as XLSX from 'xlsx';
import { loadFloorsList, clearFloor } from '../../../actions/adminAction';

import FloorsList from './FloorsList';

const Floors = () => {
  const dispatch = useDispatch();
  const floorsList = useSelector((state) => state.admin.floorsList);
  const floorListLoading = useSelector((state) => state.admin.floorListLoading);
  const dark = useSelector((state) => state.dark.data);

  useEffect(() => {
    if (floorsList.length === 0 && floorListLoading) {
      dispatch(loadFloorsList());
    }
  }, [floorsList, floorListLoading]);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  return (
    <Fragment>
      <div className='px-sm-5  px-2 admin-margin w-100 d-flex flex-column my-4 w-100'>
        <div className='mb-2'>
          <div className='d-flex align-items-center'>
            <h6 className='text-main mb-0'>Admin / Floors</h6>{' '}
            <div className='rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption '>
              {floorsList.length}
            </div>
          </div>
          <div className='d-flex w-100 align-items-center justify-content-end'>
            <div className='d-flex'>
              <div
                className='btn button-parent admin-list-btn-secondary d-flex align-items-center px-3 text-main'
                onClick={() => {
                  navigate('/admin/floors/add');
                  dispatch(clearFloor());
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  enableBackground='new 0 0 24 24'
                  height='18px'
                  viewBox='0 0 24 24'
                  width='24px'
                  fill='#ffffff'
                  className='button-child'
                >
                  <g>
                    <rect fill='none' height='18' width='18' />
                  </g>
                  <g>
                    <g>
                      <path d='M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z' />
                    </g>
                  </g>
                </svg>
                Add Floor
              </div>
            </div>
          </div>
        </div>
        <div className='flex-fill'>
          <FloorsList
            floorsList={floorsList}
            floorListLoading={floorListLoading}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Floors;
